// ViewButtons.js
import React from "react";
import { Box, Button, Grid2 } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ViewButtons = ({ buttons }) => {
    const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: 2,
        p: 2,
      }}
    >
      <Grid2 container spacing={2} justifyContent="center">
        {buttons.map((button, index) => (
          <Grid2 item xs={12} sm={6} md={4} key={index}>
            <Button
              variant="contained"
              sx={{
                borderRadius:'8px',
                background:'#5585b5',
                color:'white',
                boxShadow:'none',
                fontSize: '1.5rem',
                textTransform: 'none',
                py: 1, // Padding for larger button size
              }}
              onClick={()=>navigate(`/vehicles/${button.name}`)}
            >
              {button.label}
            </Button>
          </Grid2>
        ))}
      </Grid2>
    </Box>
  );
};

export default ViewButtons;
